import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M43.7 26.6c-.7 0-1.2-.6-1.2-1.2v-24c0-.8.5-1.4 1.2-1.4S45 .6 45 1.3v24c0 .7-.6 1.3-1.3 1.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M1.3 26.6C.6 26.6 0 26 0 25.3v-24C0 .6.6 0 1.3 0s1.2.6 1.2 1.2v24c0 .8-.5 1.4-1.2 1.4z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.3,
			y: 2,
			className: "icon-fill-primary",
			width: 42.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "43.7 24.6 29.8 24.6 26.7 15.7 23.8 20.1 21.1 18.3 19.6 24.6 1.3 24.6 1.3 22.1 17.7 22.1 19.5 14.2 23.1 16.6 27.5 10.2 31.5 22.1 43.7 22.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M24.6 45h-.7c-1.8-.2-3.4-1.3-4.3-3-.9-1.8-1-3.9 0-5.6l5-9.7 5 9.7c.9 1.8.9 3.9 0 5.6-.9 1.7-2.5 2.8-4.3 3-.2-.1-.5 0-.7 0zm0-13l-2.8 5.4c-.5 1-.5 2.3 0 3.3.5.9 1.4 1.5 2.4 1.7h.9c1-.1 1.9-.7 2.4-1.7s.6-2.3 0-3.3L24.6 32z"
		})
	]
});
export default SvgIcon;
